import React, { useEffect, useState } from 'react';
import { taskersCount } from 'common/src/api/taskers';

type Tasker = {
  id: number;
  name: string | null;
  last_name: string | null;
  email: string | null;
  phone_number: string | null;
  university: string | null;
  rut: string | null;
};

type TaskerValue = string | number | null;

const TaskersPage: React.FC = () => {
  const [taskers, setTaskers] = useState<Tasker[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [emailSearch, setEmailSearch] = useState('');
  const [phoneSearch, setPhoneSearch] = useState('');
  const [activeEmailSearch, setActiveEmailSearch] = useState('');
  const [activePhoneSearch, setActivePhoneSearch] = useState('');

  // TODO desacoplar logica de Loading de la obtencion de datos fetch
  const fetchTaskers = async (
    page: number,
    email: string = '',
    phone: string = ''
  ) => {
    setLoading(true);
    const from = (page - 1) * 100;
    const to = from + 99;

    let query = taskersCount()

    if (email) {
      query = query.ilike('email', `%${email}%`);
    }
    if (phone) {
      query = query.ilike('phone_number', `%${phone}%`);
    }

    const { data, count, error } = await query.range(from, to);

    if (error) {
      console.error('Error fetching taskers:', error);
    } else {
      setTaskers(data as Tasker[]);
      setTotalPages(Math.ceil((count || 0) / 100));
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchTaskers(currentPage, activeEmailSearch, activePhoneSearch);
  }, [currentPage, activeEmailSearch, activePhoneSearch]);

  const handleSearch = () => {
    setActiveEmailSearch(emailSearch);
    setActivePhoneSearch(phoneSearch);
    setCurrentPage(1); // Reset to first page when searching
  };

  const columns = [
    { key: 'name', label: 'Nombre' },
    { key: 'last_name', label: 'Apellido' },
    { key: 'email', label: 'Correo electrónico' },
    { key: 'phone_number', label: 'Número de teléfono' },
    { key: 'university', label: 'Universidad' },
    { key: 'rut', label: 'RUT' },
  ];

  const formatValue = (value: TaskerValue): string => {
    if (value === null) return 'N/A';
    return String(value);
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Lista de Taskers</h1>
      <div className="mb-4 flex space-x-4">
        <input
          type="text"
          placeholder="Buscar por correo electrónico"
          value={emailSearch}
          onChange={(e) => setEmailSearch(e.target.value)}
          className="p-2 border rounded"
        />
        <input
          type="text"
          placeholder="Buscar por número de teléfono"
          value={phoneSearch}
          onChange={(e) => setPhoneSearch(e.target.value)}
          className="p-2 border rounded"
        />
        <button
          onClick={handleSearch}
          className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Buscar
        </button>
      </div>
      {loading ? (
        <p>Cargando...</p>
      ) : (
        <>
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white border border-gray-300">
              <thead>
                <tr>
                  {columns.map((column) => (
                    <th
                      key={column.key}
                      className="px-4 py-2 bg-gray-100 border-b text-left"
                    >
                      {column.label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {taskers.map((tasker) => (
                  <tr
                    key={tasker.id}
                    className="hover:bg-gray-50 cursor-pointer"
                  >
                    {columns.map((column) => (
                      <td
                        key={`${tasker.id}-${column.key}`}
                        className="px-4 py-2 border-b"
                      >
                        <a
                          href={`/tasker/${tasker.id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="block w-full h-full text-black no-underline"
                        >
                          {formatValue(tasker[column.key as keyof Tasker])}
                        </a>
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="flex justify-center mt-4">
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                className={`mx-1 px-3 py-1 border ${
                  currentPage === page
                    ? 'bg-blue-500 text-white'
                    : 'bg-white text-blue-500'
                }`}
              >
                {page}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default TaskersPage;
